import * as types from './constants';

const initialState = {
  data: {},
  sendLoading: false,
  errors_api: {}
};

const actions = {
  // Send Unmasking Invitation Bulk
  [types.SEND_UNMASKING_INVITATION_BULK_REQUEST]: state => {
    const data = {
      ...state,
      sendLoading: true,
      errors_api: {}
    };

    return { ...data };
  },

  [types.SEND_UNMASKING_INVITATION_BULK_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      sendLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.SEND_UNMASKING_INVITATION_BULK_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      sendLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.SEND_UNMASKING_INVITATION_BULK_RESET]: state => {
    const data = {
      ...state,
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

